import { IKebabButton } from '../Kebab.interfaces';
import { KebabButton } from './KebabButton';

export default KebabButton as any as React.StatelessComponent<IKebabButton>;
